import { render } from "./InsightControllArea.vue?vue&type=template&id=5f3e8d2a&scoped=true"
import script from "./InsightControllArea.vue?vue&type=script&lang=js"
export * from "./InsightControllArea.vue?vue&type=script&lang=js"

import "./InsightControllArea.vue?vue&type=style&index=0&id=5f3e8d2a&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/popinsight-tools/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f3e8d2a"]])

export default __exports__